import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageTypeIcon'
})
export class MessageTypeIconPipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case 'success':
        return 'fa-check-circle';
      case 'warning':
      case 'alert':
        return 'fa-exclamation-triangle';
      default:
        return '';
    }
  }
}
